// inventoryListAtoms.js
import { atom } from 'recoil';

// Existing atoms for filters, page, and limit
export const inventoryListFilter = atom({
    key: 'inventoryListFilter',
    default: {
        brands: [],
        selected_brands: [],
        vendors: [],
        selected_vendors: [],
        subCategory: [],
        selectedCategory: [],
        subSubCategory: [],
        selectedSubCategory: []
    },
});

export const inventoryListPage = atom({
    key: 'inventoryListPage',
    default: 1,
});

export const inventoryListLimit = atom({
    key: 'inventoryListLimit',
    default: 10,
});


// New atom for search
export const inventoryListSearch = atom({
    key: 'inventoryListSearch',
    default: '',
});
// New atom for search
export const inventoryListTemplate = atom({
    key: 'inventoryListTemplate',
    default: '',
});

// New atom for search
export const inventoryListSubject = atom({
    key: 'inventoryListSubject',
    default: '',
});

